module.exports = __webpack_public_path__ + "img/2-2.cfcf4c22.jpg";